<script>
// 新建合同
import DatePickr from "@/views/widgets/date-pickr";
import UploadWithPreview from "@/views/widgets/upload-files/upload-with-preview";
import {useVuelidate} from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {alertError, successMsg} from "@/helpers/swal";
import {postCustomerContract,patchCustomerContract} from "@/service";
import serviceCompanySelect from "@/views/work-order/components/widgets/service-company-select";
import _ from 'lodash'
export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    customerId: {
      type: [String, Number],
      default: ''
    },
    customerName: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      showModal: false,
      title: this.$t('page.create'),
      form: {},
      dateConfig: {
        enableTime: false,
        // dateFormat: "Y-m-d H:S",
        dateFormat: "Y-m-d",
        time_24hr: false,
      },
      attachment: [],// 文件对象列表
      readOnly: false,
    }
  },
  validations: {
    form: {
      name: { required },
      party_a: { required },
      party_b: { required },
      begin_at: { required },
      end_at: { required },
    }
  },
  methods: {
    open(item = null, readOnly = false) {
      this.readOnly = readOnly
      this.formInit(item)
      this.showModal = true
    },
    formInit(item) {
      this.form = {
        name: null,
        party_a: null,
        party_b: null,
        begin_at: null,
        end_at: null,
        attachment: [],
        type: '1',
      }
      this.title = this.$t('page.create')
      this.attachment = []
      if (item) {
        this.title = this.$t('base.modify')
        this.form['id'] = item.id
        for (let p in this.form) {
          if (p == 'attachment') {
            this.form['attachment'] = _.map(item['attachment'], 'id')
            this.attachment = item['attachment']
          } else {
            this.form[p] = item[p]
          }
        }
        this.form.begin_at = item.begin_at.substring(0, 10)
        this.form.end_at = item.end_at.substring(0, 10)
      }
      this.form.party_a = this.customerId
      if (this.readOnly) {
        this.title = this.$t('base.detail')
      }
      // console.log(this.form)
    },
    pictureChange(ids) {
      this.form.attachment = ids
    },
    // 选择客户后自动填充其他相关字段
    setCurrentCustomer(value) {
      this.form.party_a = value
    },
    // 选择服务商
    serviceCompanyChange(value) {
      this.form.party_b = value
    },
    async save() {
      this.v$.form.$touch()
      const result = await this.v$.$validate()
      if (!result) {
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }
      let saveFun = null
      let msg = ''
      if (this.form.id) {
        // 编辑
        saveFun = patchCustomerContract
        msg = this.$t('base.modified_successfully')
      } else {
        // 新增
        saveFun = postCustomerContract
        msg = this.$t('base.add_success')
      }
      const params = _.cloneDeep(this.form)
      params.begin_at = params.begin_at + ' 00:00'
      params.end_at = params.end_at + ' 00:00'
      saveFun(params).then((res) => {
        if (![200, 201].includes(res.meta.code)) {
          alertError(this.$t('base.prompt'), res.meta.message)
          return
        }
        successMsg(msg)
        this.showModal = false
        this.$emit('refresh')
      }).catch((err) => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('page.errorOccurred'))
      })
    },
  },
  components: {
    DatePickr,
    UploadWithPreview,
    serviceCompanySelect,
  }
}
</script>
<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
      centered
  >
    <div class="modal-body border-top">
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('page.contract_name')}}<span class="text-danger" v-if="!readOnly">{{this.$t('serviceCompany.not_null')}}</span></label>
        <input type="text" class="form-control" :class="v$.form.name.$errors.length ? 'is-invalid' : ''" :placeholder="this.$t('page.contract_name')" v-model="form.name" :disabled="readOnly" />
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('page.first_party')}}<span class="text-danger" v-if="!readOnly">{{this.$t('serviceCompany.not_null')}}</span></label>
        <input type="text" class="form-control" readonly :value="customerName" />
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('page.second_party')}}<span class="text-danger" v-if="!readOnly">{{this.$t('serviceCompany.not_null')}}</span></label>
        <service-company-select :selected-service-company="form.party_b" :is-disabled="readOnly" @changed="serviceCompanyChange" />
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('serviceCompany.indate')}}<span class="text-danger" v-if="!readOnly">{{this.$t('serviceCompany.not_null')}}</span></label>
        <div v-if="!readOnly" class="d-flex justify-content-between align-items-center">
          <DatePickr :placeholder="$t('page.start-time')" :config="dateConfig" :value="form.begin_at" v-model="form.begin_at" class="flex-grow-1" />
          <span style="width: 50px;text-align: center;">-</span>
          <DatePickr :placeholder="$t('page.end-time')" :config="dateConfig" :value="form.end_at" v-model="form.end_at" class="flex-grow-1" />
        </div>
        <div v-else class="d-flex justify-content-between align-items-center">
            <input type="text" class="form-control" readonly :value="form.begin_at" />
            <span style="width: 50px;text-align: center;">-</span>
            <input type="text" class="form-control" readonly :value="form.end_at" />
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{this.$t('page.contract_file')}}</label>
        <upload-with-preview
            :value="attachment"
            input-id="uploadCertificate"
            :multiple="true"
            :can-delete="!readOnly"
            :show-upload-btn="!readOnly"
            preview-type="thumb"
            filename-prefix="contract"
            @changed="pictureChange"
        ></upload-with-preview>
      </div>
    </div>

    <div class="modal-footer v-modal-footer" v-if="!readOnly">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}
      </b-button>
      <b-button type="button" variant="primary" @click="save">{{this.$t('base.done')}}</b-button>
    </div>
  </b-modal>
</template>
